module.exports = __webpack_public_path__ + "static/media/alan_varela.e45a668a.jpg";